import React, { useEffect, useRef } from "react";
import { GoogleMap } from "@react-google-maps/api";
import TripPlaybackLayer from "../admin/TripPlaybackLayer";

const containerStyle = {
  width: "100%",
  height: "100%",
};
const EMPTY_HISTORY_CENTER = { lat: 20.5937, lng: 78.9629 };

export default function HistoryPlaybackMap({
  route = [],
  currentIndex = 0,
  currentPosition = null,
  stops = [],
  markerIcon = "",
  mapType = "roadmap",
  onMapReady,
  onManualMapInteraction,
}) {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || !window.google?.maps?.LatLngBounds || !route.length) return;
    const bounds = new window.google.maps.LatLngBounds();
    route.forEach((point) => {
      if (Number.isFinite(Number(point?.lat)) && Number.isFinite(Number(point?.lng))) {
        bounds.extend({ lat: Number(point.lat), lng: Number(point.lng) });
      }
    });
    if (!bounds.isEmpty?.()) {
      mapRef.current.fitBounds(bounds, { top: 48, right: 48, bottom: 48, left: 48 });
    }
  }, [route]);


  useEffect(() => {
    if (!mapRef.current?.setMapTypeId) return;
    mapRef.current.setMapTypeId(mapType);
  }, [mapType]);

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      // A deterministic center/zoom keeps the basemap visible before a vehicle
      // is selected or when the chosen date has no history points.
      center={route[0] || EMPTY_HISTORY_CENTER}
      zoom={route.length ? 13 : 5}
      options={{
        mapTypeId: mapType,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: true,
        gestureHandling: "greedy",
      }}
      onLoad={(mapInstance) => {
        mapRef.current = mapInstance;
        onMapReady?.(mapInstance);
      }}
      onDragStart={onManualMapInteraction}
    >
      {route.length > 0 ? (
        <TripPlaybackLayer
          route={route}
          currentIndex={currentIndex}
          currentPosition={currentPosition}
          stops={stops}
          markerIcon={markerIcon}
        />
      ) : null}
    </GoogleMap>
  );
}
